import { initConfigure } from './configure';
import { initI18n } from './i18n';
import { initInstall } from './install';
import { initRouter } from './routes';
import { initUse } from './use';

export function initGlobalAPI (App) {
  initConfigure(App);
  initI18n(App);
  initInstall(App);
  initRouter(App);
  initUse(App);
}
